export function compareObject(ob1: any, ob2: any) {
    return JSON.stringify(ob1) == JSON.stringify(ob2);
}

export function isValueExistInState(state: any) {
    return Object.keys(state).some((item: any) => Boolean(state[item]));
}

export function compareAmenityObject(prev: any, current: any, excludeAmenityKeys?: any){
    if(Object.keys(prev).length === 0 && Object.keys(current).length>3) return false;
    if(Object.keys(prev).length === 3 && Object.keys(current).length>3) return false;
    for(const key in prev){
        if(excludeAmenityKeys && excludeAmenityKeys.includes(key)) continue;
        if(Array.isArray(prev[key])){
            if(JSON.stringify(prev[key]) != JSON.stringify(current[key])){
                return false;
            }
        }else{
            if(JSON.stringify(prev[key]) != JSON.stringify(current[key])){
                return false;
            }else if(prev[key] && !current[key]){
                return false;
            } 
        }
    }
    return true;
}

export function shouldCreateHoaLogs(existingMunicipality: any, newMunicipality: any) {
    if(!existingMunicipality || !newMunicipality) {
        return false;
    }

    if(JSON.stringify(existingMunicipality.tenantLeaseRegistrationFormUrl) != JSON.stringify(newMunicipality.tenantLeaseRegistrationFormUrl)
        || existingMunicipality.registrationResolutionForm != newMunicipality.registrationResolutionForm
        || existingMunicipality.registrationRequirements != newMunicipality.registrationRequirements
        || JSON.stringify(existingMunicipality.countyOrMunicipalityRenewalForm) != JSON.stringify(newMunicipality.countyOrMunicipalityRenewalForm)
        || existingMunicipality.ownerRenewalForm != newMunicipality.ownerRenewalForm
        || existingMunicipality.renewalInstructions != newMunicipality.renewalInstructions
        || ((existingMunicipality.fees?.renewalFee && newMunicipality.fees?.renewalFee) && (existingMunicipality.fees?.renewalFee != newMunicipality.fees?.renewalFee))
    ) {
        return true;
    }
    else {
        return false;
    }
}

export function compareMunicipality(existingMunicipality: any, newMunicipality: any) {
    if(!existingMunicipality && !newMunicipality) {
        return true;
    }

    if(!existingMunicipality) {
        return false;
    }

    let copyOfExistingMunicipality = JSON.parse(JSON.stringify(existingMunicipality));

    delete copyOfExistingMunicipality.fees;
    delete copyOfExistingMunicipality.additionalInfo;

    return compareObject(copyOfExistingMunicipality, newMunicipality);
}

export const prepareBasicInforObject =(existingHoa:any,newHoa:any)=>{
    const existingObj = {
        name: existingHoa.name,
        address: existingHoa.address,
        zip: existingHoa.zip,
        coordinates: existingHoa.coordinates,
        masterHoaId: existingHoa.masterHoaId,
        phone: existingHoa.phone,
        email: existingHoa.email,
        fees: existingHoa.fees,
        paymentFrequency: existingHoa.paymentFrequency,
        hoaFeesPaymentDeadline: existingHoa.hoaFeesPaymentDeadline,
        hoaPaymentInformation: existingHoa.hoaPaymentInformation,
        boardMeetingSchedule: existingHoa.boardMeetingSchedule,

        // gate access
        isGateAccessRequired: existingHoa.isGateAccessRequired,
        residentGateAccessRequirement: existingHoa.residentGateAccessRequirement,
        guestAccessPermission: existingHoa.guestAccessPermission,
        gateAccessFormFiles: existingHoa.gateAccessFormFiles,

        // portal access
        isPortalAccessRequired: existingHoa.isPortalAccessRequired,
        hoaPortalLink: existingHoa.hoaPortalLink,
        pmcPortalLink: existingHoa.pmcPortalLink,
        residentLoginAvailable: existingHoa.residentLoginAvailable,

        // community services
        isCommunityServiceEnabled: existingHoa.isCommunityServiceEnabled,
        communityServices: existingHoa.communityServices,

        // property manager
        propertyManagementCompanyAvailable: existingHoa.propertyManagementCompanyAvailable,
        propertyManager: existingHoa.propertyManager,

        // client information
        hoaClientInfo: existingHoa.hoaClientInfo,
        hoaEvents: existingHoa.hoaEvents,
    }

    const newObj = {
        name: newHoa.name,
        address: newHoa.address,
        zip: newHoa.zip,
        coordinates: newHoa.coordinates,
        masterHoaId: newHoa.masterHoaId,
        phone: newHoa.phone,
        email: newHoa.email,
        fees: newHoa.fees,
        paymentFrequency: newHoa.paymentFrequency,
        hoaFeesPaymentDeadline: newHoa.hoaFeesPaymentDeadline,
        hoaPaymentInformation: newHoa.hoaPaymentInformation,
        boardMeetingSchedule: newHoa.boardMeetingSchedule,

        // gate access
        isGateAccessRequired: newHoa.isGateAccessRequired,
        residentGateAccessRequirement: newHoa.residentGateAccessRequirement,
        guestAccessPermission: newHoa.guestAccessPermission,
        gateAccessFormFiles: existingHoa.gateAccessFormFiles,

        // portal access
        isPortalAccessRequired: newHoa.isPortalAccessRequired,
        hoaPortalLink: existingHoa.hoaPortalLink,
        pmcPortalLink: existingHoa.pmcPortalLink,
        residentLoginAvailable: newHoa.residentLoginAvailable,

        // community services
        isCommunityServiceEnabled: existingHoa.isCommunityServiceEnabled,
        communityServices: newHoa.communityServices,

        // property manager
        propertyManagementCompanyAvailable: newHoa.propertyManagementCompanyAvailable,
        propertyManager: newHoa.propertyManager,

        // client information
        hoaClientInfo: newHoa.hoaClientInfo,
        hoaEvents: newHoa.hoaEvents,
    }
    return {existingObj, newObj}
}

export function isClientInfoChanged(existingHoa:any, newHoa:any) {
    const existingObj = {
        hoaClientInfo:existingHoa.hoaClientInfo
    }

    const newObj = {
        hoaClientInfo: newHoa.hoaClientInfo
    }
    return compareObject(existingObj, newObj);
}

export function compareHoaBasicInfo(existingHoa:any, newHoa:any) {
    const existingObj = {
        name: existingHoa.name,
        address: existingHoa.address,
        zip: existingHoa.zip,
        coordinates: existingHoa.coordinates,
        masterHoaId: existingHoa.masterHoaId,
        phone: existingHoa.phone,
        email: existingHoa.email,
        fees: existingHoa.fees,
        paymentFrequency: existingHoa.paymentFrequency,
        hoaFeesPaymentDeadline: existingHoa.hoaFeesPaymentDeadline,
        hoaPaymentInformation: existingHoa.hoaPaymentInformation,
        boardMeetingSchedule: existingHoa.boardMeetingSchedule,

        // gate access
        isGateAccessRequired: existingHoa.isGateAccessRequired,
        residentGateAccessRequirement: existingHoa.residentGateAccessRequirement,
        guestAccessPermission: existingHoa.guestAccessPermission,
        gateAccessFormFiles: existingHoa.gateAccessFormFiles,

        // portal access
        isPortalAccessRequired: existingHoa.isPortalAccessRequired,
        hoaPortalLink: existingHoa.hoaPortalLink,
        pmcPortalLink: existingHoa.pmcPortalLink,
        residentLoginAvailable: existingHoa.residentLoginAvailable,

        // community services
        isCommunityServiceEnabled: existingHoa.isCommunityServiceEnabled,
        communityServices: existingHoa.communityServices,

        // property manager
        propertyManagementCompanyAvailable: existingHoa.propertyManagementCompanyAvailable,
        propertyManager: existingHoa.propertyManager,
        hoaEvents: existingHoa.hoaEvents,

    }

    const newObj = {
        name: newHoa.name,
        address: newHoa.address,
        zip: newHoa.zip,
        coordinates: newHoa.coordinates,
        masterHoaId: newHoa.masterHoaId,
        phone: newHoa.phone,
        email: newHoa.email,
        fees: newHoa.fees,
        paymentFrequency: newHoa.paymentFrequency,
        hoaFeesPaymentDeadline: newHoa.hoaFeesPaymentDeadline,
        hoaPaymentInformation: newHoa.hoaPaymentInformation,
        boardMeetingSchedule: newHoa.boardMeetingSchedule,

        // gate access
        isGateAccessRequired: newHoa.isGateAccessRequired,
        residentGateAccessRequirement: newHoa.residentGateAccessRequirement,
        guestAccessPermission: newHoa.guestAccessPermission,
        gateAccessFormFiles: newHoa.gateAccessFormFiles,

        // portal access
        isPortalAccessRequired: newHoa.isPortalAccessRequired,
        hoaPortalLink: existingHoa.hoaPortalLink,
        pmcPortalLink: existingHoa.pmcPortalLink,
        residentLoginAvailable: newHoa.residentLoginAvailable,

        // community services
        isCommunityServiceEnabled: existingHoa.isCommunityServiceEnabled,
        communityServices: newHoa.communityServices,

        // property manager
        propertyManagementCompanyAvailable: newHoa.propertyManagementCompanyAvailable,
        propertyManager: newHoa.propertyManager,
        hoaEvents: newHoa.hoaEvents,
    }

    return compareObject(existingObj, newObj);
}

export function isMunicipalityChange(existingHoa: any, newHoa: any) {
    const existingObj = {
        municipality: existingHoa.municipality,
        market: existingHoa.market,
        city: existingHoa.city
    }

    const newObj = {
        municipality: newHoa.municipality,
        market: newHoa.market,
        city: newHoa.city
    }

    return compareObject(existingObj, newObj);
}

export function isPropertyOverviewUpdate(existingProperty: any, newProperty: any){
    const existingObj = {
        externalId: existingProperty.hoaPropertyDetails.externalId,
        street: existingProperty.info.street,
        organizationName: existingProperty.organizationName,
        organizationId: existingProperty.organizationId,
        onboardingDate: existingProperty.hoaPropertyDetails.onboardingDate,
        currentOwner: existingProperty.hoaPropertyDetails.currentOwner,
        dateBoughtByOwner: existingProperty.hoaPropertyDetails.dateBoughtByOwner,
        securitized: existingProperty.hoaPropertyDetails.securitized,
        propertyAppraisalValue: existingProperty.hoaPropertyDetails.propertyAppraisalValue,
        propertyAppraisalAdditionalInfo: existingProperty.hoaPropertyDetails.propertyAppraisalAdditionalInfo,
        underManagement: existingProperty.hoaPropertyDetails.underManagement,
        underManagementAdditionalInfo: existingProperty.hoaPropertyDetails.underManagementAdditionalInfo,
        underManagementEffectiveSoldDateAdditionalInfo: existingProperty.hoaPropertyDetails.underManagementEffectiveSoldDateAdditionalInfo,
        effectiveSoldDate: existingProperty.hoaPropertyDetails.effectiveSoldDate,
        acquisitionDate: existingProperty.hoaPropertyDetails.acquisitionDate,
        amount: existingProperty.hoaPropertyDetails.amount,
        responseDeadline: existingProperty.hoaPropertyDetails.responseDeadline,
        responseMethod: existingProperty.hoaPropertyDetails.responseMethod,
        propertyNoticeFiles: existingProperty.propertyNoticeFiles,
    }

    const newObj = {
        externalId: newProperty.hoaPropertyDetails.externalId,
        street: newProperty.info.street,
        organizationName: newProperty.organizationName,
        organizationId: newProperty.organizationId,
        onboardingDate: newProperty.hoaPropertyDetails.onboardingDate,
        currentOwner: newProperty.hoaPropertyDetails.currentOwner,
        dateBoughtByOwner: newProperty.hoaPropertyDetails.dateBoughtByOwner,
        securitized: newProperty.hoaPropertyDetails.securitized,
        propertyAppraisalValue: newProperty.hoaPropertyDetails.propertyAppraisalValue,
        propertyAppraisalAdditionalInfo: newProperty.hoaPropertyDetails.propertyAppraisalAdditionalInfo,
        underManagement: newProperty.hoaPropertyDetails.underManagement,
        underManagementAdditionalInfo: newProperty.hoaPropertyDetails.underManagementAdditionalInfo,
        underManagementEffectiveSoldDateAdditionalInfo: newProperty.hoaPropertyDetails.underManagementEffectiveSoldDateAdditionalInfo,
        effectiveSoldDate: newProperty.hoaPropertyDetails.effectiveSoldDate,
        acquisitionDate: newProperty.hoaPropertyDetails.acquisitionDate,
        amount: newProperty.hoaPropertyDetails.amount,
        responseDeadline: newProperty.hoaPropertyDetails.responseDeadline,
        responseMethod: newProperty.hoaPropertyDetails.responseMethod,
        propertyNoticeFiles: newProperty.propertyNoticeFiles,
    }

    return compareObject(existingObj, newObj);
}

export function isPropertyViolationBasicInfoUpdate(existingProperty: any, newProperty: any) {
    const existingObj = {
        avgViolation: existingProperty.hoaPropertyDetails.avgViolation,
        numberOfViolation: existingProperty.hoaPropertyDetails.numberOfViolation,
        assesmentFee: existingProperty.hoaPropertyDetails.assesmentFee,
        assesmentFeeFrequency: existingProperty.hoaPropertyDetails.assesmentFeeFrequency,
        assesmentStatus: existingProperty.hoaPropertyDetails.assesmentStatus,
        assessmentFeeSubHoa: existingProperty.hoaPropertyDetails.assessmentFeeSubHoa,
        assessmentFeeFrequencySubHoa: existingProperty.hoaPropertyDetails.assessmentFeeFrequencySubHoa,

    }

    const newObj = {
        avgViolation: newProperty.hoaPropertyDetails.avgViolation,
        numberOfViolation: newProperty.hoaPropertyDetails.numberOfViolation,
        assesmentFee: newProperty.hoaPropertyDetails.assesmentFee,
        assesmentFeeFrequency: newProperty.hoaPropertyDetails.assesmentFeeFrequency,
        assesmentStatus: newProperty.hoaPropertyDetails.assesmentStatus,
        assessmentFeeSubHoa: newProperty.hoaPropertyDetails.assessmentFeeSubHoa,
        assessmentFeeFrequencySubHoa: newProperty.hoaPropertyDetails.assessmentFeeFrequencySubHoa,
    }

    return compareObject(existingObj, newObj);
}

export function hasNewFileBeenAdded(noticeFiles: any) {
    let hasNewFileAdded = false;
    if(Array.isArray(noticeFiles)) {
        noticeFiles.forEach((file: any) => {
            if(file instanceof File) {
                hasNewFileAdded = true;
            }
        });
    }
​
    return hasNewFileAdded;    
}

export function isNotResolvedPreviously(prevViolations:any, objectId: string) {
    const foundVioltionIndex = prevViolations.findIndex((violation:any) => {
        return violation.objectId === objectId;
    });

    return foundVioltionIndex == -1 ||  prevViolations[foundVioltionIndex].noticeStatus != 'resolved';
}

export function getResolvedViolationList(prevViolations:any, currentViolations:any) {
    const resolvedViolationList:any = [];

    for (const violation of currentViolations) {
        if (violation.noticeStatus === 'resolved' && isNotResolvedPreviously(prevViolations, violation.objectId)) {
            resolvedViolationList.push(violation);
        }
    }

    return resolvedViolationList;
}

export function getUpdatedViolationListForChangeLog(prevViolations:any, currentViolations:any) {
    let violationsWithAddedFile:any = [];
    currentViolations = currentViolations.filter((violation:any) => {
        if(violation.objectId && violation?.violationNoticeFiles && hasNewFileBeenAdded(violation.violationNoticeFiles)) {
            violationsWithAddedFile.push(violation);
        }
        else {
            return true;
        }
    });

    const prevViolationsCopy = JSON.parse(JSON.stringify(prevViolations));
    const currentViolationsCopy = JSON.parse(JSON.stringify(currentViolations));

    // remove notice status
    for (let violation of prevViolationsCopy) {
        delete violation.noticeStatus;
    }

    for (let violation of currentViolationsCopy) {
        delete violation.noticeStatus;
    }
​
    const prevViolationsCopyJsonStrings = prevViolationsCopy.map((violation:any) => JSON.stringify(violation));
    let currentViolationsCopyJsonStrings = currentViolationsCopy.map((violation:any) => JSON.stringify(violation));
​
    const filteredArray = currentViolationsCopyJsonStrings.filter((currentViolation:any, index:number) => {
        if (currentViolationsCopy[index].objectId && currentViolationsCopy[index].isDeleted === false && prevViolationsCopyJsonStrings.indexOf(currentViolation) === -1) {
            return true;   
        }
    });
​
    const filteredArrayCopy = filteredArray.map((violation:any) => JSON.parse(violation));
    violationsWithAddedFile.forEach((violation: any) => filteredArrayCopy.push(violation));
​
    return filteredArrayCopy;
}

export function getCreatedOrUpdatedViolations(prevViolations:any, currentViolations:any, shouldIgnoreDeletedViolations:boolean) {
    let violationsWithAddedFile:any = [];
    currentViolations = currentViolations.filter((violation:any) => {
        if(violation?.violationNoticeFiles && hasNewFileBeenAdded(violation.violationNoticeFiles)) {
            violationsWithAddedFile.push(violation);
        }
        else {
            return true;
        }
    });
​
    const prevViolationsCopy = prevViolations.map((violation:any) => JSON.stringify(violation));
    let currentViolationsCopy = currentViolations.map((violation:any) => JSON.stringify(violation));
​
    const filteredArray = currentViolationsCopy.filter((currentViolation:any, index:number) => {
        if (shouldIgnoreDeletedViolations && currentViolations[index].isDeleted === false && prevViolationsCopy.indexOf(currentViolation) === -1) {
            return true;
            
        }
        else if (!shouldIgnoreDeletedViolations && prevViolationsCopy.indexOf(currentViolation) === -1){
            return true;
        }
        
    });
​
    const filteredArrayCopy = filteredArray.map((violation:any) => JSON.parse(violation));
    violationsWithAddedFile.forEach((violation: any) => filteredArrayCopy.push(violation));
​
    return filteredArrayCopy;
}

export function getCreatedOrUpdatedHoaDues(prevHoaDues:any, currentHoaDues:any, shouldIgnoreDeletedHoaDues: boolean) {
    let hoaDuesWithAddedFile:any = [];
    currentHoaDues = currentHoaDues.filter((hoaDue:any) => {
        if(hoaDue?.hoaDuesNoticeFiles && hasNewFileBeenAdded(hoaDue.hoaDuesNoticeFiles)) {
            hoaDuesWithAddedFile.push(hoaDue);
        }
        else {
            return true;
        }
    });
​
    const prevHoaDuesCopy = prevHoaDues.map((hoaDue:any) => JSON.stringify(hoaDue));
    let currentHoaDuesCopy = currentHoaDues.map((hoaDue:any) => JSON.stringify(hoaDue));
​
    const filteredArray = currentHoaDuesCopy.filter((currentHoaDue:any, index:number) => {
        if (shouldIgnoreDeletedHoaDues && currentHoaDues[index].isDeleted === false && prevHoaDuesCopy.indexOf(currentHoaDue) === -1) {
            return true;
            
        }
        else if (!shouldIgnoreDeletedHoaDues && prevHoaDuesCopy.indexOf(currentHoaDue) === -1){
            return true;
        }
        
    });
​
    const filteredArrayCopy = filteredArray.map((hoaDue:any) => JSON.parse(hoaDue));
    hoaDuesWithAddedFile.forEach((hoaDue: any) => filteredArrayCopy.push(hoaDue));
​
    return filteredArrayCopy;
}


export function deepCompare(obj1:any, obj2:any, changedFields?:[]) {
    if ((obj1 != null && obj2 != null) && typeof obj1 === 'object' && typeof obj2 === 'object') {
        // Check if both are arrays
        if (Array.isArray(obj1) && Array.isArray(obj2)) {
            if (obj1.length !== obj2.length) {
                return false;
            }
            for (let i = 0; i < obj1.length; i++) {
                if (!deepCompare(obj1[i], obj2[i])) {
                    return false;
                }
            }
            return true;
        } else {
            // Get the keys of both objects
            const keys1 = Object.keys(obj1);
            const keys2 = Object.keys(obj2);

            if (keys1.length !== keys2.length) {
                return false;
            }
            for (let key of keys1) {
                if (!deepCompare(obj1[key], obj2[key])) { 
                    return false;
                }
            }

            return true;
        }
    } else {
        return obj1 === obj2;
    }
}

export function deepCompareFields(obj1:any, obj2:any, excludeAmenityKeys?:any) {
    const unequalFields = new Set();

    function compare(obj1:any, obj2:any, path = '') {
        if ((obj1 != null && obj2 != null) && typeof obj1 === 'object' && typeof obj2 === 'object') {
            // Check if both are arrays
            if (Array.isArray(obj1) && Array.isArray(obj2)) {
                if (obj1.length !== obj2.length) {
                    unequalFields.add(path);
                    return;
                }
                for (let i = 0; i < obj1.length; i++) {
                    compare(obj1[i], obj2[i], path);
                }
            } else {
                // Get the keys of both objects
                const keys1 = Object.keys(obj1);
                const keys2 = Object.keys(obj2);

                const allKeys = new Set([...keys1, ...keys2]);

                for (let key of allKeys) {
                    if(excludeAmenityKeys && excludeAmenityKeys.includes(key)) continue;
                    const newPath = key;
                    if (!obj1.hasOwnProperty(key) || !obj2.hasOwnProperty(key)) {
                        unequalFields.add(newPath);
                    } else {
                        compare(obj1[key], obj2[key], newPath);
                    }
                }
            }
        } else {
            if (obj1 !== obj2) {
                unequalFields.add(path);
            }
        }
    }

    compare(obj1, obj2);
    return Array.from(unequalFields);
}

const findDifferingProperties = (arr1:any[], arr2:any[], path = '', tab = ''):any[] => {
    const differingProps = new Set();
  
    const deepCompare = (obj1: any, obj2: any, currentPath: string) => {

        if (isObject(obj1) && isObject(obj2)) {

            if (Array.isArray(obj1) && Array.isArray(obj2)) {
                if (obj1.length !== obj2.length && !restrictedPathChecker(currentPath)) {
                    differingProps.add(currentPath);
                }
                for (let i = 0; i < Math.max(obj1.length, obj2.length); i++) {
                    deepCompare(obj1[i], obj2[i], `${currentPath}[${i}]`);
                }
            } else {
                const keys = new Set([...Object.keys(obj1 || {}), ...Object.keys(obj2 || {})]);
                for (const key of keys) {
                    const value1 = obj1?.[key];
                    const value2 = obj2?.[key];
                    const newPath = currentPath ? `${currentPath}.${key}` : key;

                    if (value1 === undefined || value2 === undefined) {
                        differingProps.add(newPath);
                    } else {
                        deepCompare(value1, value2, newPath);
                    }
                }
            }
        } else if (obj1 !== obj2) {
            if(tab==="violation" && restrictedPathChecker(path)){
                if(Object.keys(obj2).length){
                 differingProps.add(obj2)
                }
                return
            }

            handleDifferingProperties(currentPath);
        }
    };
  
    const isObject = (value:any) => value && typeof value === 'object';
  
    const handleDifferingProperties = (key:any) => { 
      if (tab === 'newAvialableAmenities') {
        if (key.includes('amenityName')) differingProps.add('amenityName');
        if (key.includes('address')) differingProps.add('amenityAddress');
        if (path.includes('rulesAndRegulations')) differingProps.add('rulesAndRegulations');
        if (key.includes('rulesAndRegulationDocuments')) differingProps.add('rulesAndRegulationDocuments');
        if (key.includes('paymentMethod')) differingProps.add('paymentMethod');
        if (key.includes('amenityPhotos')) differingProps.add('amenityPhotos');
        if (key.includes('amenityAccessName')) differingProps.add('amenityAccessName');
        if (key.includes('availability')) differingProps.add('availability');
        if (key.includes('additionalAmenitiesDocument')) differingProps.add('additionalAmenitiesDocument');
        if (key.includes('amenityType')) differingProps.add('amenityType');
        if (key === 'locations') differingProps.add('locations');
      } else if (path.includes('availableAmenitiesListDetails') && key.includes('address')) {
        differingProps.add('amenityAddress');
      } else if (tab === 'amenityEvents' && key.includes('newsLetterNotificationFiles')) {
        differingProps.add('newsLetterNotificationFiles');
      } else if (tab === 'amenityEvents' && key.includes('amenityTags')) {
        differingProps.add('amenityTags');
      } else if ((tab === 'amenityEvents' && key.includes('address')) || (path.includes('amenityEvents') && key.includes('address'))) {
        differingProps.add('amenityEventAddress');
      } else {
        differingProps.add(key);
      }
    };
  
    const maxLength = Math.max(arr1.length, arr2.length);
  
    for (let i = 0; i < maxLength; i++) {
      const obj1 = arr1[i] || {};
      const obj2 = arr2[i] || {};
  
      deepCompare(obj1, obj2, path);
    }
  
    return Array.from(differingProps);
  };

  const restrictedOptions=["restrictedOptions","mandatoryOptions","loudAnimalsRestrictedOptions","loudResidentsRestrictedOptions","offensiveBehaviorRestrictedOptions","unlicensedVehicleRestrictedOptions","drivewayParkingRestrictedOptions","regulatedAlterationsOptions","regulatedMaintenanceOptions","storageOfWaste","visibleWaste"]
  const restrictedPathChecker =(path:string)=>{
    let result = false
     for (let i =0; i< restrictedOptions.length; i++){
      if(path.includes(restrictedOptions[i])){
        result = true
        break
      }
     }
     return result
  }
export function deepCompareFieldsWithPaths(obj1: any, obj2: any, excludeAmenityKeys?: string[],tab?:string) {
    const unequalFields: string[] = [];
    function compare(obj1: any, obj2: any, path = '') {

        if (typeof obj1 === 'object' && typeof obj2 === 'object' && obj1 !== null && obj2 !== null) {
            // Handle arrays
            if (Array.isArray(obj1) && Array.isArray(obj2)) {
                if (obj1.length !== obj2.length) {
                    if(path && !restrictedPathChecker(path)){
                        unequalFields.push(path);
                    }
                        return unequalFields.push(...findDifferingProperties(obj1,obj2,path,tab))
                }
                for (let i = 0; i < Math.max(obj1.length,obj2.length); i++) {
                    compare(obj1[i], obj2[i], `${path}[${i}]`);
                }
            } else {
                // Handle objects
                const keys1 = Object.keys(obj1);
                const keys2 = Object.keys(obj2);
                const allKeys = new Set([...keys1, ...keys2]);

                for (const key of allKeys) {
                    if (excludeAmenityKeys && excludeAmenityKeys.includes(key)) continue;

                    const newPath = path ? `${path}.${key}` : key;

                    if (!obj1.hasOwnProperty(key) || !obj2.hasOwnProperty(key)) {
                        unequalFields.push(newPath);
                    } else {
                        compare(obj1[key], obj2[key], newPath);
                    }
                }
            }
        } else if (obj1 !== obj2) {
            if(tab==="violation" && restrictedPathChecker(path)){
                if(Object.keys(obj2).length){
                    unequalFields.push(obj2)
                }
                return
            }
            pathLogiCheck(path,unequalFields)
        }
    }
    const pathLogiCheck=(path:string,unequalFields:any[])=>{
        if(tab === "newAvialableAmenities"){
            if(path.includes("amenityName")){
                unequalFields.push("amenityName")
            }
            if(path.includes("address")){
                unequalFields.push("amenityAddress")
            }
            if(path.includes("rulesAndRegulations")){
                unequalFields.push("rulesAndRegulations")
            }
            if(path.includes("rulesAndRegulationDocuments")){
                unequalFields.push("rulesAndRegulationDocuments")
            }
            if(path.includes("paymentMethod")){
                unequalFields.push("paymentMethod")
            }
            if(path.includes("amenityPhotos")){
                unequalFields.push("amenityPhotos")
            }
            if(path.includes("amenityAccessName")){
                unequalFields.push("amenityAccessName")
            }
            if(path.includes("availability")){
                unequalFields.push("availability")
            }
            if(path.includes("additionalAmenitiesDocument")){
                unequalFields.push("additionalAmenitiesDocument")
            }
            if(path.includes("amenityType")){
                unequalFields.push("amenityType")
            }
            if(path === "locations"){
                unequalFields.push("locations")
            }
        }
        else
        if(path.includes("availableAmenitiesListDetails")){
            if(path.includes("address")){
                unequalFields.push("amenityAddress")
            }
            if(path.includes("googleCoordinates")){
              unequalFields.push("googleCoordinates")
            }
            if(path.includes("availableAmenitiesList")){
                unequalFields.push("availableAmenitiesList")
            }
        }
        else if(tab === "amenityEvents" && path.includes("newsLetterNotificationFiles")){
                unequalFields.push("newsLetterNotificationFiles")
            }
        else if(tab === "amenityEvents" && path.includes("amenityTags")){
                unequalFields.push("amenityTags")  
        }
        else if((tab==="amenityEvents"&& path.includes("address"))||(path.includes("amenityEvents") && path.includes("address"))){
            unequalFields.push("amenityEventAddress")
        }
        else{
            unequalFields.push(path);
        }
    }

    compare(obj1, obj2);
    let result = unequalFields.filter(item => !["fileName","url","","id"].includes(item));
    return result;
}

export function compareProcedure(prevState: any, currentState: any) {
    const existingObj = {
        AdditionalInformationOfDateOfLeasing: prevState?.AdditionalInformationOfDateOfLeasing,
        AdditionalInformationOfLeasingCap: prevState?.AdditionalInformationOfLeasingCap,
        AdditionalInformationOfRenewalFee: prevState?.AdditionalInformationOfRenewalFee,
        categories: prevState?.categories,
        keywords: prevState?.keywords,
        leasingCap: prevState?.leasingCap,
        leasingRegulationsAndRestrictions: prevState?.leasingRegulationsAndRestrictions,
        leasingRestrictionDate: prevState?.leasingRestrictionDate,
        reference: prevState?.reference,
        registrationAddminFee: prevState?.registrationAddminFee,
        renewalFee: prevState?.renewalFee,
        registrationAndRenewalInstruction: prevState?.registrationAndRenewalInstruction,
        sourceDocuments: prevState?.sourceDocuments,
        tenantLeaseRegistrationRenewalForm: prevState?.tenantLeaseRegistrationRenewalForm,
        tenantRegistrationConveninceFee: prevState?.tenantRegistrationConveninceFee,

    }

    const newObj = {
        AdditionalInformationOfDateOfLeasing: currentState?.AdditionalInformationOfDateOfLeasing,
        AdditionalInformationOfLeasingCap: currentState?.AdditionalInformationOfLeasingCap,
        AdditionalInformationOfRenewalFee: currentState?.AdditionalInformationOfRenewalFee,
        categories: currentState?.categories,
        keywords: currentState?.keywords,
        leasingCap: currentState?.leasingCap,
        leasingRegulationsAndRestrictions: currentState?.leasingRegulationsAndRestrictions,
        leasingRestrictionDate: currentState?.leasingRestrictionDate,
        reference: currentState?.reference,
        registrationAddminFee: currentState?.registrationAddminFee,
        renewalFee: currentState?.renewalFee,
        registrationAndRenewalInstruction: currentState?.registrationAndRenewalInstruction,
        sourceDocuments: currentState?.sourceDocuments,
        tenantLeaseRegistrationRenewalForm: currentState?.tenantLeaseRegistrationRenewalForm,
        tenantRegistrationConveninceFee: currentState?.tenantRegistrationConveninceFee,
        
    }

    return compareObject(existingObj, newObj);

}